import { withAuthenticationRequired } from '@tom-ui/utils'
import { TenantRoleDto, useAdminStore } from '@tom-ui/admin'
import { AddHoldTypePage, HoldTypesPage } from '@tom-ui/planning'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router'

export const HoldTypesListWrapper = withAuthenticationRequired(
  observer(() => {
    const { roleStore } = useAdminStore()

    useEffect(() => {
      roleStore.load()
    }, [roleStore])

    const userRoleOptions = useMemo(() => {
      return roleStore.data.map((role: TenantRoleDto) => ({ label: role.name, value: role.id }))
    }, [roleStore.data])

    return <HoldTypesPage userRoleOptions={userRoleOptions} />
  }),
)

export const AddHoldTypeWrapper = withAuthenticationRequired(
  observer(() => {
    const { id } = useParams<{ id: string }>()
    const { roleStore } = useAdminStore()

    useEffect(() => {
      roleStore.load()
    }, [roleStore])

    const userRoleOptions = useMemo(() => {
      return roleStore.data.map((role: TenantRoleDto) => ({ label: role.name, value: role.id }))
    }, [roleStore.data])

    return <AddHoldTypePage key={id ?? 'add'} userRoleOptions={userRoleOptions} />
  }),
)
